import { CareTeam } from "src/careflow/ph-core/fhir-client/resources";
import { CareTeamRepository } from "../../../ports/out/repositories";
import { AxiosFHIRRepository } from "./AxiosFHIRRepository";
import { TokenSource } from "./TokenSource";
import axiosFhirInstance from "../instance/axiosFhirInstance";

export class FHIRCareTeamRepository extends AxiosFHIRRepository<CareTeam> implements CareTeamRepository {
  constructor(tokenSource?: TokenSource) {
    super('CareTeam', axiosFhirInstance, tokenSource);
  }
}